export default __webpack_public_path__ + "static/media/archive.3212e6bf.svg";